module.exports = __webpack_public_path__ + "img/selected7-min.685d1ca7.png";